import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';

import RichText from '../rich-text';
import VideoComponent from '../video';

type WrapperProps = {
  reverse: boolean;
};

export const VideoText = styled.div<WrapperProps>(
  props => css`
    display: flex;
    flex-direction: ${props.reverse ? 'row' : 'row-reverse'};

    ${media.smallOnly`
      flex-direction: column;
    `};
  `
);

type Props = {
  reverse: boolean;
  width: Array<string>;
};
export const Text = styled(RichText)<Props>(
  props => css`
    width: ${props.reverse ? props.width[0] : props.width[1]};
    padding-left: ${!props.reverse ? layout.measurements.spacing100 : 0};
    padding-right: ${props.reverse ? layout.measurements.spacing100 : 0};

    ${media.smallOnly`
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      padding-top: ${!props.reverse ? layout.measurements.spacing100 : 0};
      padding-bottom: ${props.reverse ? layout.measurements.spacing100 : 0};
    `};
  `
);

export const Video = styled(VideoComponent)<Props>(
  props => css`
    width: ${props.reverse ? props.width[1] : props.width[0]};
    padding-left: ${props.reverse ? layout.measurements.spacing100 : 0};
    padding-right: ${!props.reverse ? layout.measurements.spacing100 : 0};

    ${media.smallOnly`
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      padding-top: ${props.reverse ? layout.measurements.spacing100 : 0};
      padding-bottom: ${!props.reverse ? layout.measurements.spacing100 : 0};
    `};
  `
);
